export const pubCompanyTypes = {
  PUB_COMPANY_ONCHANGE: "PUB_COMPANY_ONCHANGE",
};
